// src/services/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://call-log.flydaallo.com'
});

export default api;
